import { styled } from '@mui/material/styles';
import Tabs, { TabsProps } from '@mui/material/Tabs';

interface IProps extends TabsProps {
    size?: "large" | "medium" | "small";
}

export const MprcBarTabs = styled
    ((props: TabsProps) => (<Tabs{...props} textColor="inherit" />))<IProps>
    (
        ({ theme, size = "small" }) => ({
            '& .MuiTab-root': {
                ...theme.extended.tab.tab,
                ...theme.extended.tab[size]
            },
            '& .Mui-selected': theme.extended.tab.selected,
            '& .MuiTabs-indicator': theme.extended.tab.indicator,
            '& .MuiTabs-flexContainer': theme.extended.tab.container
        })
    );
